<template>
    <button 
        v-on:click="onClick()" 
        class="btn btn-block my-1" 
        :disabled="disabled"
        v-bind:class="{ 
            'btn-primary': primary && !isOutlined, 
            'btn-secondary': secondary && !isOutlined,
            'btn-outline-primary': isOutlined && primary,
            'btn-outline-secondary': isOutlined && secondary,
        }"
        :title="title"
    >
        <slot></slot>
    </button>
</template>

<script>

export default {
    components: {  },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false,
            default: 'button'
        },
        onClick: {
            type: Function,
            required: false,
            default: ()=>{}
        },
        primary: {
            type: Boolean,
            required: false,
            default: true
        },
        secondary: {
            type: Boolean,
            required: false,
            default: false
        },
        isOutlined: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
</style>
